import axios from 'axios';
import Component from 'vue-class-component';
import { Vue, Inject } from 'vue-property-decorator';
import AccountService from '@/account/account.service';
import idleService from '@/shared/idle-service';

@Component({
  watch: {
    $route() {
      this.$root.$emit('bv::hide::modal', 'login-page');
    },
  },
})
export default class LoginForm extends Vue {
  @Inject('accountService')
  private accountService: () => AccountService;
  public authenticationError = null;
  public login = null;
  public password = null;
  public rememberMe: boolean = null;
  public showPassword = false;

  public doLogin(): void {
    const data =
      'username=' +
      encodeURIComponent(this.login) +
      '&password=' +
      encodeURIComponent(this.password) +
      '&remember-me=' +
      this.rememberMe +
      '&submit=Login';
    axios
      .post('api/authentication', data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then(() => {
        this.authenticationError = false;

        // Guarda el inicio del período de inactividad.
        // La fecha se conserva después de recargar.
        idleService.beginIdleSession();

        this.$root.$emit('bv::hide::modal', 'login-page');

        window.location.reload();
      })
      .catch(() => {
        this.authenticationError = true;
      });
  }
  // Agrega este método para manejar el evento 'keydown.enter' en el campo de nombre de usuario
  public handleUsernameEnterKey(event: any): void {
    if (event.key === 'Enter') {
      // Mueve el foco al campo de contraseña
      this.$refs.passwordInput.focus();
    }
  }

  public handleSubmit(): void {
    axios.get('management/info').then(() => {
      this.$nextTick(() => {
        this.doLogin();
      });
    });
  }
}
